import { customerExperiencesNavigationResource } from '@jira/router-resources__customer-experiences-navigation/src/customerExperiencesNavigationResource.tsx';
import { MenuIdCustomerExperiences } from '@jira/navigation-apps__constants/src/MenuIdCustomerExperiences.tsx';
import { getServiceDeskSettingsResources } from '@jira/router-resources__service-desk-common/src/getServiceDeskSettingsResources.tsx';
import { LazyAtlassianNavigation } from '@jira/navigation-apps__atlassian-navigation/src/async.tsx';
import { serviceProjectLayout } from '@jira/platform__layouts-service-project-layout/src/index.tsx';
import { NORMAL_EARLY_ASSET_STRATEGY } from '@jira/platform__common-constants/src/ssr-early-assets.tsx';
import { createEntry } from '@jira/platform__routing-route-entry/src/createEntry.tsx';
import { helpCenterSettingsAgentStudioRoute } from '@jira/router-routes__help-center-settings-routes/src/helpCenterSettingsAgentStudioRoute.tsx';
import { AgentOverviewPageSkeleton } from '@jira/platform__skeletons/src/ui/help-center/agent-overview-page/AgentOverviewPageSkeleton.tsx';
import type { Route } from '@atlassian/react-resource-router';
import {
	AgentStudioOverviewPage,
	LazyAgentStudioOverviewPage,
	csmAgentOverviewPageEntryPoint,
} from './ui/agent-studio/index.tsx';

export const helpCenterSettingsAgentStudioRouteEntry: Route = createEntry(
	helpCenterSettingsAgentStudioRoute,
	() => ({
		group: 'helpcenter-settings',
		perfMetricKey: 'help-center-settings.agent-studio',
		// For either return undefined scenario, it will fallback to the component config below
		entryPoint() {
			return csmAgentOverviewPageEntryPoint;
		},
		// eslint-disable-next-line no-restricted-syntax
		component: AgentStudioOverviewPage,
		skeleton: AgentOverviewPageSkeleton,
		layout: serviceProjectLayout,
		navigation: {
			menuId: MenuIdCustomerExperiences,
		},
		resources: [
			...getServiceDeskSettingsResources(),
			// TODO: AVP route resources here
			customerExperiencesNavigationResource,
		],
		forPaint: [LazyAtlassianNavigation, LazyAgentStudioOverviewPage],
		earlyAssets: NORMAL_EARLY_ASSET_STRATEGY,
		bifrost: {
			bifrostGroup: 'shell-only',
		},
	}),
);
